export default __webpack_public_path__ + "a597336.png";